import React, { useState, useEffect } from "react";
import { apiFetch } from "../utils/api";

const COLORES = ["#2563EB","#F97316","#16A34A","#92400E","#6B7280","#e0e0e0","#DC2626","#888","#CA8A04","#7C3AED","#DB2777","#0891B2"];
const NOMBRES = ["Azul","Naranja","Verde","Marron","Gris","Blanco","Rojo","Negro","Amarillo","Violeta","Rosado","Aqua"];

function nombreHilo(buffer, hilo) {
  const idx = (parseInt(hilo)-1)%12;
  return `H${(parseInt(buffer)-1)*12+parseInt(hilo)} ${NOMBRES[idx]}`;
}

function calcOcupados(fusiones, fibra_id) {
  const atras = [], adelante = [];
  fusiones.forEach(f => {
    if(f.tipo==="splitter_entrada" && String(f.fibra_entrada_id)===String(fibra_id))
      atras.push({buffer:parseInt(f.buffer_entrada), hilo:parseInt(f.hilo_entrada)});
    else if(f.tipo==="splitter_salida" && String(f.fibra_salida_id)===String(fibra_id))
      adelante.push({buffer:parseInt(f.buffer_salida), hilo:parseInt(f.hilo_salida)});
    else if(f.tipo==="hilo_hilo"){
      if(String(f.fibra_entrada_id)===String(fibra_id)){
        if((f.direccion||"devolver")==="devolver") atras.push({buffer:parseInt(f.buffer_entrada),hilo:parseInt(f.hilo_entrada)});
        else adelante.push({buffer:parseInt(f.buffer_entrada),hilo:parseInt(f.hilo_entrada)});
      }
      if(String(f.fibra_salida_id)===String(fibra_id))
        adelante.push({buffer:parseInt(f.buffer_salida),hilo:parseInt(f.hilo_salida)});
    }
    else if(f.tipo==="buffer_completo" && String(f.fibra_salida_id)===String(fibra_id))
      adelante.push({buffer:parseInt(f.buffer_salida),hilo:parseInt(f.hilo_salida)});
  });
  return {atras, adelante};
}

function DirBtn({value, onChange}) {
  return (
    <div style={{display:"flex",gap:4}}>
      <button onClick={()=>onChange("devolver")} style={{padding:"3px 10px",borderRadius:6,border:"1px solid #374151",background:value==="devolver"?"#78350F":"transparent",color:value==="devolver"?"#FBBF24":"#9CA3AF",fontSize:11,cursor:"pointer"}}>← Entrada</button>
      <button onClick={()=>onChange("adelante")} style={{padding:"3px 10px",borderRadius:6,border:"1px solid #374151",background:value==="adelante"?"#064E3B":"transparent",color:value==="adelante"?"#34D399":"#9CA3AF",fontSize:11,cursor:"pointer"}}>Salida →</button>
    </div>
  );
}

function HiloSelect({fibras, fibra_id, buffer, hilo, onFibra, onBuffer, onHilo, fusiones, direccion}) {
  const f = fibras.find(x=>String(x.id)===String(fibra_id));
  const tipo_hilos = f ? parseInt(f.tipo_hilos) : 12;
  const buffers = Math.ceil(tipo_hilos/12);
  const hilosEnBuffer = Math.min(12, tipo_hilos-(parseInt(buffer||1)-1)*12);
  const ocupados = (fibra_id && fusiones) ? calcOcupados(fusiones, fibra_id) : {atras:[],adelante:[]};
  const estaOcupado = (b,h) => {
    const lista = direccion==="devolver" ? ocupados.atras : ocupados.adelante;
    return lista.some(o=>o.buffer===parseInt(b)&&o.hilo===parseInt(h));
  };
  const S = {select:{background:"#1a1a2e",border:"1px solid #374151",borderRadius:6,color:"#F9FAFB",padding:"6px 8px",fontSize:12,width:"100%",marginBottom:4}};
  return (
    <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
      <select style={{...S.select,flex:2,marginBottom:0}} value={fibra_id||""} onChange={e=>onFibra(e.target.value)}>
        <option value="">Fibra...</option>
        {fibras.map(f=><option key={f.id} value={f.id}>{f.nombre} ({f.tipo_hilos}h)</option>)}
      </select>
      {fibra_id&&<>
        <select style={{...S.select,flex:1,marginBottom:0}} value={buffer||1} onChange={e=>{onBuffer(e.target.value);onHilo(1);}}>
          {Array.from({length:buffers},(_,i)=>(
            <option key={i+1} value={i+1}>B{i+1} {NOMBRES[i%12]}</option>
          ))}
        </select>
        <select style={{...S.select,flex:1,marginBottom:0}} value={hilo||1} onChange={e=>onHilo(e.target.value)}>
          {Array.from({length:hilosEnBuffer},(_,i)=>{
            const h=i+1, abs=(parseInt(buffer||1)-1)*12+h, ocupado=estaOcupado(buffer||1,h);
            return <option key={h} value={h} disabled={ocupado}>{ocupado?"✗ ":""}H{abs} {NOMBRES[i%12]}{ocupado?" (usado)":""}</option>;
          })}
        </select>
      </>}
    </div>
  );
}

function primerHiloDisp(fibras, fusiones, fibra_id, buffer, direccion) {
  const f = fibras.find(x=>String(x.id)===String(fibra_id));
  if(!f) return 1;
  const hilosEnBuf = Math.min(12, parseInt(f.tipo_hilos)-(parseInt(buffer)-1)*12);
  const ocu = calcOcupados(fusiones, fibra_id);
  const lista = direccion==="devolver" ? ocu.atras : ocu.adelante;
  for(let h=1;h<=hilosEnBuf;h++){
    if(!lista.some(o=>o.buffer===parseInt(buffer)&&o.hilo===h)) return h;
  }
  return 1;
}

export default function FusionSplitter({mufa_id, splitters, fibras, fusionesExistentes, onGuardado, canEdit}) {

  // Helper: cargar estado de un splitter desde fusionesExistentes
  const cargarEstadoSp = (spIdStr) => {
    const ent  = fusionesExistentes.find(f=>f.tipo==="splitter_entrada"&&String(f.splitter_id)===spIdStr);
    const sp   = splitters.find(s=>String(s.id)===spIdStr);
    const n    = sp ? parseInt(sp.tipo.split("x")[1]) : 0;
    const sals = fusionesExistentes.filter(f=>f.tipo==="splitter_salida"&&String(f.splitter_id)===spIdStr);
    // Si no hay fusion splitter_entrada, leer directamente del registro mufa_splitters
    const fibra  = ent ? String(ent.fibra_entrada_id) : (sp?.fibra_entrada_id ? String(sp.fibra_entrada_id) : "");
    const buffer = ent ? ent.buffer_entrada : (sp?.buffer_entrada || 1);
    const hilo   = ent ? ent.hilo_entrada   : (sp?.hilo_entrada   || 1);
    return {
      sp_fibra:  fibra,
      sp_buffer: buffer,
      sp_hilo:   hilo,
      sp_dir:    ent ? (ent.direccion||"devolver") : "devolver",
      salidas:   Array.from({length:n},(_,i)=>{
        const sal = sals.find(s=>parseInt(s.splitter_salida_num)===i+1);
        // Si no hay sal, hilo por defecto es i+1 pero sin bloquear
        return {num:i+1, fibra_id:sal?String(sal.fibra_salida_id):"", fibra_dest:sal?String(sal.fibra_salida_id):"", buffer:sal?sal.buffer_salida:1, hilo:sal?sal.hilo_salida:0, direccion:sal?sal.direccion:"adelante", fusion_id:sal?sal.id:null};
      }),
    };
  };

  const spIdInit = splitters[0]?String(splitters[0].id):"";
  const initState = cargarEstadoSp(spIdInit);

  const [sp_id,     setSpIdRaw]  = useState(spIdInit);
  const [sp_fibra,  setSpFibra]  = useState(initState.sp_fibra);
  const [sp_buffer, setSpBuffer] = useState(initState.sp_buffer);
  const [sp_hilo,   setSpHilo]   = useState(initState.sp_hilo);
  const [sp_dir,    setSpDir]    = useState(initState.sp_dir);
  const [salidas,   setSalidas]  = useState(initState.salidas);
  // Primera salida libre — calcula sin depender de numSalidas
  const primeraSalidaLibre = (spIdStr)=>{
    const sp = splitters.find(s=>String(s.id)===spIdStr);
    const n = sp ? parseInt(sp.tipo.split("x")[1]) : 8;
    for(let i=1;i<=n;i++){
      const yaAsig = fusionesExistentes.some(f=>f.tipo==="splitter_salida"&&String(f.splitter_id)===spIdStr&&parseInt(f.splitter_salida_num)===i);
      if(!yaAsig) return i;
    }
    return 1;
  };
  const [nuevaSalida,setNuevaSalida]= useState({num:primeraSalidaLibre(spIdInit),fibra_id:"",buffer:1,hilo:1,direccion:"adelante"});
  const [error,     setError]    = useState("");
  const [msgOk,     setMsgOk]    = useState("");
  const [saving,    setSaving]   = useState(false);

  // Cambiar splitter: recargar todo el estado de ese splitter
  const setSpId = (newId) => {
    const estado = cargarEstadoSp(newId);
    setSpIdRaw(newId);
    setSpFibra(estado.sp_fibra);
    setSpBuffer(estado.sp_buffer);
    setSpHilo(estado.sp_hilo);
    setSpDir(estado.sp_dir);
    setSalidas(estado.salidas);
    setError("");
    setMsgOk("");
    // Auto-seleccionar primera salida libre del nuevo splitter
    const sp2 = splitters.find(s=>String(s.id)===newId);
    const n2 = sp2 ? parseInt(sp2.tipo.split("x")[1]) : 0;
    const sals2 = fusionesExistentes.filter(f=>f.tipo==="splitter_salida"&&String(f.splitter_id)===newId);
    setNuevaSalida({num:primeraSalidaLibre(newId),fibra_id:"",buffer:1,hilo:1,direccion:"adelante"});
  };

  const splitterSel = splitters.find(s=>String(s.id)===String(sp_id));
  const numSalidas  = splitterSel ? parseInt(splitterSel.tipo.split("x")[1]) : 0;

  // Cuando cambia splitter, ajustar salidas
  useEffect(()=>{
    if(!splitterSel) return;
    const n = parseInt(splitterSel.tipo.split("x")[1]);
    setSalidas(prev=>{
      if(prev.length===n) return prev;
      if(n<prev.length){
        const extras = prev.filter(s=>s.num>n&&s.fibra_id);
        if(extras.length>0){
          if(!window.confirm(`Al reducir el splitter se perderán ${extras.length} salidas asignadas. ¿Continuar?`)) return prev;
        }
        return prev.slice(0,n).map((s,i)=>({...s,num:i+1}));
      }
      return Array.from({length:n},(_,i)=>prev[i]||{num:i+1,fibra_id:"",buffer:1,hilo:i+1,direccion:"adelante",fusion_id:null});
    });
  },[sp_id]);

  // Fusiones virtuales — solo fusiones del splitter actual + otras fusiones no-splitter
  const fusionesVirtuales = [
    ...fusionesExistentes.filter(f=>
      f.tipo!=="splitter_entrada"&&f.tipo!=="splitter_salida" ||
      (f.tipo==="splitter_entrada"&&String(f.splitter_id)!==String(sp_id)) ||
      (f.tipo==="splitter_salida"&&String(f.splitter_id)!==String(sp_id))
    ),
    ...(sp_fibra&&sp_id?[{
      tipo: "splitter_entrada",
      fibra_entrada_id:sp_fibra, buffer_entrada:parseInt(sp_buffer), hilo_entrada:parseInt(sp_hilo),
      fibra_salida_id:null, buffer_salida:parseInt(sp_buffer), hilo_salida:parseInt(sp_hilo),
    }]:[]),
    ...salidas.filter(s=>s.fibra_id).map(s=>({
      tipo:"splitter_salida",
      fibra_salida_id:s.fibra_id, buffer_salida:parseInt(s.buffer), hilo_salida:parseInt(s.hilo),
    })),
    ...(nuevaSalida.fibra_id?[{
      tipo:"splitter_salida",
      fibra_salida_id:nuevaSalida.fibra_id, buffer_salida:parseInt(nuevaSalida.buffer), hilo_salida:parseInt(nuevaSalida.hilo),
    }]:[]),
  ];

  const aplicarSalida = () => {
    if(!nuevaSalida.fibra_id){ setError("Selecciona la fibra de destino"); return; }
    const hAbs = (parseInt(nuevaSalida.buffer)-1)*12+parseInt(nuevaSalida.hilo);
    // Verificar hilo del splitter
    const esSpHilo = sp_fibra&&String(nuevaSalida.fibra_id)===String(sp_fibra)&&parseInt(nuevaSalida.buffer)===parseInt(sp_buffer)&&parseInt(nuevaSalida.hilo)===parseInt(sp_hilo);
    const dirBloquea = sp_dir==="salida"?"adelante":"devolver";
    if(esSpHilo&&nuevaSalida.direccion===dirBloquea){ setError(`H${hAbs} es la entrada del Splitter ${splitterSel?.tipo}`); return; }
    // Verificar duplicado
    const ocupados = calcOcupados([
      ...fusionesExistentes.filter(f=>f.tipo!=="splitter_salida"),
      ...salidas.filter(s=>s.fibra_id&&s.num!==nuevaSalida.num).map(s=>({tipo:"splitter_salida",fibra_salida_id:s.fibra_id,buffer_salida:parseInt(s.buffer),hilo_salida:parseInt(s.hilo)})),
    ], nuevaSalida.fibra_id);
    const lista = nuevaSalida.direccion==="devolver"?ocupados.atras:ocupados.adelante;
    if(lista.some(o=>o.buffer===parseInt(nuevaSalida.buffer)&&o.hilo===parseInt(nuevaSalida.hilo))){ setError(`H${hAbs} ya está en uso`); return; }
    setError("");
    setSalidas(prev=>prev.map(s=>s.num===nuevaSalida.num?{...s,...nuevaSalida}:s));
    // Avanzar al siguiente
    const sig = salidas.find(s=>s.num>nuevaSalida.num&&!s.fibra_id);
    setNuevaSalida({num:sig?sig.num:nuevaSalida.num, fibra_id:"", buffer:1, hilo:1, direccion:"adelante"});
  };

  const guardar = async() => {
    if(!sp_id){ setError("Selecciona el splitter"); return; }
    setSaving(true); setError(""); setMsgOk("");
    // Si sp_fibra vacío, tomar de splitterSel
    const fibraEnt = sp_fibra || splitterSel?.fibra_entrada_id;
    const bufEnt   = sp_buffer || splitterSel?.buffer_entrada || 1;
    const hiloEnt  = sp_hilo  || splitterSel?.hilo_entrada   || 1;
    if(!fibraEnt){ setError("Este splitter no tiene fibra de entrada configurada. Edita el splitter primero."); setSaving(false); return; }

    // Borrar fusiones splitter existentes
    const toDelete = fusionesExistentes.filter(f=>(f.tipo==="splitter_entrada"||f.tipo==="splitter_salida")&&String(f.splitter_id)===String(sp_id));
    for(const f of toDelete){
      await apiFetch("/mufa_diagram.php?mufa_id="+mufa_id,{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({accion:"fusion",id:f.id})});
    }
    // Guardar nuevas
    const fusiones = [
      {tipo:"splitter_entrada", fibra_entrada_id:parseInt(fibraEnt), buffer_entrada:parseInt(bufEnt), hilo_entrada:parseInt(hiloEnt), fibra_salida_id:parseInt(fibraEnt), buffer_salida:parseInt(bufEnt), hilo_salida:parseInt(hiloEnt), direccion:sp_dir==="entrada"?"devolver":"adelante", splitter_id:parseInt(sp_id), splitter_salida_num:null},
      ...salidas.filter(s=>s.fibra_id).map(s=>({tipo:"splitter_salida", fibra_entrada_id:parseInt(fibraEnt), buffer_entrada:parseInt(bufEnt), hilo_entrada:parseInt(hiloEnt), fibra_salida_id:parseInt(s.fibra_dest||s.fibra_id), buffer_salida:parseInt(s.buffer), hilo_salida:parseInt(s.hilo), direccion:s.direccion, dir_salida:s.direccion, splitter_id:parseInt(sp_id), splitter_salida_num:s.num}))
    ];
    const r = await apiFetch("/mufa_diagram.php?mufa_id="+mufa_id,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({accion:"fusiones_lote",fusiones})});
    setSaving(false);
    if(r.success){ setMsgOk("Guardado — "+r.guardadas+" fusiones"); onGuardado(); }
    else setError(r.error||"Error al guardar");
  };

  const S = {
    card:{background:"rgba(255,255,255,0.03)",borderRadius:8,padding:"12px",marginBottom:10,border:"1px solid #1e2a4a"},
    cardTitle:{fontSize:13,fontWeight:600,color:"#C4B5FD",marginBottom:8},
    select:{background:"#1a1a2e",border:"1px solid #374151",borderRadius:6,color:"#F9FAFB",padding:"6px 8px",fontSize:12,width:"100%",marginBottom:4},
    row:{display:"flex",alignItems:"center",gap:5,padding:"4px 8px",borderRadius:5,background:"rgba(124,58,237,0.08)",border:"1px solid #2a2a4a",marginBottom:3},
    btnPrimary:{background:"#7C3AED",color:"#fff",border:"none",borderRadius:6,padding:"8px 16px",cursor:"pointer",fontSize:12},
    btnDanger:{background:"rgba(239,68,68,0.15)",color:"#F87171",border:"1px solid rgba(239,68,68,0.3)",borderRadius:4,padding:"2px 8px",cursor:"pointer",fontSize:11},
    btnGuardar:{background:"#059669",color:"#fff",border:"none",borderRadius:6,padding:"10px 0",cursor:"pointer",fontSize:13,fontWeight:600,width:"100%",marginTop:8},
  };

  return (
    <div>
      {/* SELECTOR SPLITTER */}
      <div style={S.card}>
        <div style={S.cardTitle}>Salidas del splitter</div>
        <select style={S.select} value={sp_id} onChange={e=>setSpId(e.target.value)}>
          <option value="">Selecciona splitter...</option>
          {splitters.map((s,si)=>{
            const perdMap={"1x2":3.5,"1x4":7.3,"1x8":10.5,"1x16":13.9,"1x32":17.2};
            const fibNom = s.fibra_entrada_id ? fibras.find(f=>String(f.id)===String(s.fibra_entrada_id))?.nombre||"?" : "sin fibra";
            const hiloAbs = s.fibra_entrada_id ? (parseInt(s.buffer_entrada||1)-1)*12+parseInt(s.hilo_entrada||1) : "?";
            return <option key={s.id} value={s.id}>Splitter {si+1} — {s.tipo} N{s.nivel} ({perdMap[s.tipo.split("x")[1]]||"?"}dB) · H{hiloAbs} {fibNom}</option>;
          })}
        </select>
        {sp_id&&sp_fibra&&(
          <div style={{display:"flex",alignItems:"center",gap:6,marginTop:6,padding:"5px 10px",background:"rgba(30,123,191,0.15)",borderRadius:6}}>
            <div style={{width:8,height:8,borderRadius:"50%",background:COLORES[(parseInt(sp_hilo)-1)%12]}}/>
            <span style={{fontSize:11,color:"#60A5FA"}}>
              Entrada: H{(parseInt(sp_buffer)-1)*12+parseInt(sp_hilo)} {nombreHilo(sp_buffer,sp_hilo)} {sp_dir==="devolver"?"← Entrada":"Salida →"} → Splitter {splitterSel?.tipo}
            </span>
          </div>
        )}
      </div>

      {/* SALIDAS SPLITTER */}
      {sp_id&&splitterSel&&(
        <div style={S.card}>
          <div style={S.cardTitle}>Sección 2 — Salidas del splitter {splitterSel.tipo} ({numSalidas} salidas)</div>
          {canEdit&&(
            <div style={{background:"rgba(0,0,0,0.2)",borderRadius:8,padding:"10px",marginBottom:10,border:"1px solid #2a2a4a"}}>
              <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:6,flexWrap:"wrap"}}>
                <span style={{fontSize:11,color:"#9CA3AF"}}>Salida #</span>
                <select style={{...S.select,flex:0,width:60,marginBottom:0}} value={nuevaSalida.num} onChange={e=>setNuevaSalida(x=>({...x,num:parseInt(e.target.value)}))}>
                  {Array.from({length:numSalidas},(_,i)=><option key={i+1} value={i+1}>{i+1}</option>)}
                </select>
                <DirBtn value={nuevaSalida.direccion} onChange={v=>{
                  const fusSinActual = [
                    ...fusionesExistentes.filter(f=>f.tipo!=="splitter_entrada"&&f.tipo!=="splitter_salida"),
                    ...(sp_fibra&&sp_id?[{tipo:"splitter_entrada",fibra_entrada_id:sp_fibra,buffer_entrada:parseInt(sp_buffer),hilo_entrada:parseInt(sp_hilo),fibra_salida_id:null,buffer_salida:parseInt(sp_buffer),hilo_salida:parseInt(sp_hilo)}]:[]),
                    ...salidas.filter(s=>s.fibra_id&&s.num!==nuevaSalida.num).map(s=>({tipo:"splitter_salida",fibra_salida_id:s.fibra_id,buffer_salida:parseInt(s.buffer),hilo_salida:parseInt(s.hilo)})),
                  ];
                  const h = primerHiloDisp(fibras, fusSinActual, nuevaSalida.fibra_id, nuevaSalida.buffer, v);
                  setNuevaSalida(x=>({...x,direccion:v,hilo:h}));
                }}/>
              </div>
              <select style={{...S.select,marginBottom:4}} value={nuevaSalida.fibra_dest||nuevaSalida.fibra_id||""} onChange={e=>setNuevaSalida(x=>({...x,fibra_dest:e.target.value,fibra_id:e.target.value,buffer:1,hilo:1}))}>
                <option value="">Fibra destino...</option>
                {fibras.map(f=><option key={f.id} value={f.id}>{f.nombre} ({f.tipo_hilos}h)</option>)}
              </select>
              <HiloSelect fibras={fibras} fibra_id={nuevaSalida.fibra_id} buffer={nuevaSalida.buffer} hilo={nuevaSalida.hilo}
                onFibra={v=>setNuevaSalida(x=>({...x,fibra_id:v,buffer:1,hilo:1}))}
                onBuffer={v=>setNuevaSalida(x=>({...x,buffer:v,hilo:1}))}
                onHilo={v=>setNuevaSalida(x=>({...x,hilo:v}))}
                fusiones={[
                  ...fusionesExistentes.filter(f=>f.tipo!=="splitter_entrada"&&f.tipo!=="splitter_salida"),
                  ...(sp_fibra&&sp_id?[{
                    tipo: sp_dir==="salida"?"splitter_salida":"splitter_entrada",
                    fibra_entrada_id:sp_fibra, buffer_entrada:parseInt(sp_buffer), hilo_entrada:parseInt(sp_hilo),
                    fibra_salida_id:sp_fibra,  buffer_salida:parseInt(sp_buffer),  hilo_salida:parseInt(sp_hilo),
                  }]:[]),
                  ...salidas.filter(s=>s.fibra_id&&s.num!==nuevaSalida.num).map(s=>({
                    tipo:"splitter_salida",
                    fibra_salida_id:s.fibra_id, buffer_salida:parseInt(s.buffer), hilo_salida:parseInt(s.hilo),
                  })),
                ]}
                direccion={nuevaSalida.direccion}
              />
              {error&&<p style={{color:"#F87171",fontSize:11,margin:"4px 0 0",padding:"4px 8px",background:"rgba(239,68,68,0.1)",borderRadius:4}}>{error}</p>}
              <button onClick={aplicarSalida} style={{...S.btnPrimary,width:"100%",padding:"6px 0",marginTop:6,fontSize:12}}>
                Aplicar salida {nuevaSalida.num}
              </button>
            </div>
          )}

          {/* Lista salidas asignadas */}
          {salidas.filter(s=>s.fibra_id).length===0&&<p style={{fontSize:11,color:"#4B5563",margin:0}}>Sin salidas asignadas.</p>}
          {salidas.filter(s=>s.fibra_id).map((s)=>{
            const abs=(parseInt(s.buffer)-1)*12+parseInt(s.hilo);
            const col=COLORES[(parseInt(s.hilo)-1)%12];
            const nom=NOMBRES[(parseInt(s.hilo)-1)%12];
            return (
              <div key={s.num} style={S.row}>
                <div style={{width:18,height:18,borderRadius:"50%",background:"#4C1D95",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#C4B5FD",fontWeight:700,flexShrink:0}}>{s.num}</div>
                <span style={{fontSize:10,color:"#C4B5FD"}}>Sal {s.num}</span>
                <span style={{fontSize:10,color:"#7C3AED"}}>→F→</span>
                <div style={{width:7,height:7,borderRadius:"50%",background:col,flexShrink:0}}/>
                <span style={{fontSize:11,color:col}}>H{abs} {nom}</span>
                <span style={{fontSize:10,color:s.direccion==="devolver"?"#FBBF24":"#34D399"}}>{s.direccion==="devolver"?"← Ent":"Sal →"}</span>
                {s.fibra_id&&<span style={{fontSize:9,color:"#6B7280"}}>{fibras.find(f=>String(f.id)===String(s.fibra_id))?.nombre||""}</span>}
                <div style={{flex:1}}/>
                {canEdit&&<button onClick={()=>setSalidas(prev=>prev.map(x=>x.num===s.num?{...x,fibra_id:""}:x))} style={S.btnDanger}>X</button>}
              </div>
            );
          })}
        </div>
      )}

      {/* GUARDAR */}
      {canEdit&&(
        <div>
          {msgOk&&<p style={{color:"#34D399",fontSize:12,margin:"0 0 6px",textAlign:"center"}}>{msgOk}</p>}
          <button onClick={guardar} disabled={saving} style={S.btnGuardar}>
            {saving?"Guardando...":"💾 Guardar splitter y salidas"}
          </button>
        </div>
      )}
    </div>
  );
}
